export const NEW_OR_EXISTING_PATIENT_STRINGS = {
    NewPatient: "I'm a new patient",
    ExistingPatient: "I've seen this doctor before",
};

export const PatientRadioValues = {
    NEW_PATIENT: 'newPatient',
    EXISTING_PATIENT: 'existingPatient',
};

export const RadioGroupOrientations = {
    Horizontal: 'horizontal',
    Vertical: 'vertical',
};
